import * as types from "../ActionTypes/actionTypes.js";
import { CALL_API } from "../middleware/api";

export function getInProgressMaintenance(criteria) {
  const options = { headers: { "Content-Type": "application/json", Accept: "application/json" }, method: "GET" };
  return {
    [CALL_API]: {
      endpoint: `journeyPlan/inProgressMaintenance/${criteria}`,
      authenticated: true,
      config: options,
      types: [
        types.GET_IN_PROGRESS_MAINTENANCE_REQUEST,
        types.GET_IN_PROGRESS_MAINTENANCE_SUCCESS,
        types.GET_IN_PROGRESS_MAINTENANCE_FAILURE,
      ],
    },
  };
}
export function getAssetsInprogressInspections() {
  const options = {
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    method: "GET",
  };
  let endpoint = "journeyPlan/inProgressInspections";

  return {
    [CALL_API]: {
      endpoint: endpoint,
      authenticated: true,
      config: options,
      types: [
        types.GET_IN_PROGRESS_INSPECTIONS_REQUEST,
        types.GET_IN_PROGRESS_INSPECTIONS_SUCCESS,
        types.GET_IN_PROGRESS_INSPECTIONS_FAILURE,
      ],
    },
  };
}



// WEBPACK FOOTER //
// ./src/reduxRelated/actions/journeyPlanHelperActions.js